import React from 'react';
import OnHoverTooltip from '../tables/shared/OnHoverTooltip';
import { bookingStatusOptions, getOptionsObjectValue, translateOptionValue } from '../exl/shared/translations';
import { useTranslation } from 'react-i18next';

const BookingStatusDisplay = ({ booking }) => {
    const label = translateOptionValue(booking?.status, bookingStatusOptions);
    const description = getOptionsObjectValue(bookingStatusOptions, booking?.status)?.description;
    const { t } = useTranslation();

    return (
        <>
            {t(label) ?? "-"}
            {description && (
                <OnHoverTooltip
                    dataFor='course-status'
                    tooltipPlace='right'
                    tooltipEffect='solid'
                >
                    <span className='oi oi-info c-steelblue padding-left-10px' style={{ fontSize: '10px' }} />
                    {t(description)}
                </OnHoverTooltip>
            )}
        </>
    );
}

export default BookingStatusDisplay;